import { render, staticRenderFns } from "./contactBanner2.vue?vue&type=template&id=f481734e&scoped=true&"
import script from "./contactBanner2.vue?vue&type=script&lang=js&"
export * from "./contactBanner2.vue?vue&type=script&lang=js&"
import style1 from "./contactBanner2.vue?vue&type=style&index=1&id=f481734e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f481734e",
  null
  
)

export default component.exports